module.exports = __webpack_public_path__ + "static/media/edit.67e56e52.svg";